import type React from 'react';

/**
 * Creatomate's 'interactive' mode draws the composition at 80% of its iframe,
 * keeping a 10% off-canvas margin on every side for selection handles. To make
 * the composition itself fill the preview box, the iframe is oversized to 125%
 * and offset by -12.5% inside an `overflow: hidden` container (1.25 × 0.8 = 1).
 *
 * 'player' mode has no margin, so it must NOT get this treatment — there the
 * oversize crops an eighth off every edge (PLAT-11508).
 *
 * Shared by the warm path (pre-warmed iframe docked via `positionOver`) and the
 * cold path (`CreatomateClipPreview`'s own container) so both render the canvas
 * at the same size (PLAT-11863).
 */
export const INTERACTIVE_IFRAME_FIT: Readonly<React.CSSProperties> = {
  position: 'absolute',
  top: '-12.5%',
  left: '-12.5%',
  width: '125%',
  height: '125%',
};
